import React, { useContext } from 'react'
import { AppContext } from '../../context/app'
import QRCode from 'react-qr-code'
import RoundCrossIcon from '../../assets/imgComponents/roundCrossIcon'

const TipJarModal = () => {
  const { tipJarModalLink, setTipJarModalLink } = useContext(AppContext)

  return (
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none h-full  ">
      {/* <div style={{}} className={`relative w-screen lg:w-[40vw] xl:w-[90rem]`}> */}
      <div style={{}} className={`relative `}>
        <div
          style={{
            backgroundImage: 'linear-gradient(45deg, #0D0E3A, #ED2B63)',
            fontFamily: 'Arial',
            border: '',
            borderRadius: '10px',
          }}
          className="shadow-lg relative flex flex-col w-full pb-4 "
        >
          <div className=" ">
            <div
              className=" z-20 right-0 my-2 mx-2"
              onClick={() => {
                setTipJarModalLink('')
              }}
            >
              <RoundCrossIcon color="#fff" className="h-6 cursor-pointer float-right w-6 " />
            </div>
            <div className="flex flex-col justify-center items-center w-full px-6">
              <p className=" w-full text-center xl:text-3xl mt-4 font-bold text-white">
                SUPPORT OUR ONGOING <br /> WORK IN THE COMMUNITY
              </p>
              <p className=" w-full text-center text-xs xl:text-xl mt-4 font-bold text-white">
                PLEASE SCAN TO DONATE
              </p>
            </div>
            <div className="flex justify-center items-center relative my-4 px-6 xl:px-0">
              <div className="p-4 rounded-lg" style={{ background: '#00000060' }}>
                <QRCode value={tipJarModalLink} />
                <div className=" flex justify-between items-center w-full mt-4 text-white">
                  <div style={{ width: '40%', border: '0.25px solid #fff' }} />
                  <p style={{ width: '10%' }}>OR</p>
                  <div style={{ width: '40%', border: '0.25px solid #fff' }} />
                </div>
                <div className="flex justify-center items-center w-full relative mt-4 ">
                  <button
                    className="px-4 py-2 w-full rounded-full font-bold"
                    style={{
                      color: '#fff',
                      backgroundImage: 'linear-gradient(45deg, #397D9F, #371B7A)',
                    }}
                    onClick={() => window.open(tipJarModalLink, '_blank')}
                  >
                    Click to Pay
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TipJarModal
